export const GET_STRATEGIES = 'strategies/GET_STRATEGIES'
export const GET_STRATEGY = 'strategies/GET_STRATEGY'
export const ADD_STRATEGY = 'strategies/ADD_STRATEGIES'
export const EDIT_STRATEGY = 'strategies/EDIT_STRATEGIES'
export const DELETE_STRATEGIES = 'strategies/DELETE_STRATEGIES'
export const START_LOADING_STRATEGIES =
  'strategies/START_LOADING_STRATEGIES'
export const STOP_LOADING_STRATEGIES =
  'strategies/STOP_LOADING_STRATEGIES'